import React from 'react';
import Zoom from 'react-reveal/Zoom';
import ContactSection from '../components/ContactSection';
import Map from '../components/Map';

export default function Home() {
  return (
    <div>
      <div className="container">
        <ContactSection />
        <Zoom>
          <Map />
        </Zoom>
      </div>
    </div>
  );
}
